import styled from 'styled-components';

const Wrapper = styled.div`
  ${({ bgColor }) => (bgColor ? `background-color: ${bgColor};` : null)}
  ${({ border }) => (border ? `border: ${border};` : null)}
  ${({ borderBottom }) => (borderBottom ? `border-bottom: ${borderBottom};` : null)}
  ${({ borderTop }) => (borderTop ? `border-top: ${borderTop};` : null)}
  ${({ borderRadius }) => (borderRadius ? `border-radius: ${borderRadius};` : null)}
  ${({ color }) => (color ? `color: ${color};` : null)}
  ${({ font }) => (font ? `font-family: ${font};` : null)}
  ${({ fontSize }) => (fontSize ? `font-size: ${fontSize};` : null)}
  ${({ fontWeight }) => (fontWeight ? `font-weight: ${fontWeight};` : null)}
  ${({ height }) => (height ? `height: ${height};` : null)}
  ${({ lineHeight }) => (lineHeight ? `line-height: ${lineHeight};` : null)}
  ${({ margin }) => (margin ? `margin: ${margin};` : null)}
  ${({ maxWidth }) => (maxWidth ? `max-width: ${maxWidth};` : null)}
  ${({ minHeight }) => (minHeight ? `min-height: ${minHeight};` : null)}
  ${({ maxHeight }) => (maxHeight ? `max-height: ${maxHeight};` : null)}
  ${({ padding }) => (padding ? `padding: ${padding};` : null)}
  ${({ textAlign }) => (textAlign ? `text-align: ${textAlign};` : null)}
  ${({ uppercase }) => (uppercase ? 'text-transform: uppercase;' : null)}
  ${({ width }) => (width ? `width: ${width};` : null)};
  ${({ cursor }) => (cursor ? `cursor: ${cursor};` : null)};
  ${({ letterSpacing }) => (letterSpacing ? `letter-spacing: ${letterSpacing};` : null)};
  ${({ fontStyle }) => (fontStyle ? `font-style: ${fontStyle};` : null)};
  ${({ display }) => (display ? `display: ${display};` : null)};
`;

export default Wrapper;
